import { canUseDOM } from 'exenv';

export const validCostCondition = ({ title }) => title?.value !== '';

export const validTab = ({ title, costConditions }) =>
  title?.value !== '' && costConditions.length !== 0;

export const trans = (x) => `translate(${x}px)`;

export const getOffsetForCurrentTab = (tabElems, containerWidth, currentStepIndex, limits) => {
  let xOffset = 0;

  for (let i = 0; i < tabElems.current.length; i++) {
    const elem = tabElems.current[i].current;
    if (!elem) {
      continue;
    }

    var style = elem.currentStyle || window.getComputedStyle(elem);
    const width = elem.offsetWidth;

    const ml = parseInt(style.marginLeft) || 0;
    const mr = parseInt(style.marginRight) || 0;

    if (i === currentStepIndex) {
      // no offset for first tab
      if (i === 0) {
        break;
      }

      xOffset += ml + width / 2;
      break;
    } else {
      xOffset += ml + width + mr;
    }
  }

  return Math.max(limits.current.min, Math.min(limits.current.max, containerWidth / 2 - xOffset));
};

export const getStepElementsChanged = (stepElems, prevStepElems) => 
  // return true just at the point when the step elem references get populated
  // need this hook to know when to update list posn on first *useful* render
  // where items have size
  (
    stepElems.length && stepElems[0] !== null && prevStepElems.length && prevStepElems[0] === null
  );

export const isMobSafari = () => {
  if (!canUseDOM) {
    return false; // SSR
  }

  const userAgent = window.navigator.userAgent;

  return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);
};
